module.exports = __webpack_public_path__ + "static/media/35d5e62f-ef9f-4db7-8541-944c102c324e.8dfeed1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/35d5e62f-ef9f-4db7-8541-944c102c324e.jpg
// module id = 812
// module chunks = 0